import React, { useState, useEffect } from 'react';
import { dataMeet } from '../../../data/data_meet';
import './CloneMeetingModal.css';

const CloneMeetingModal = ({ 
  isOpen, 
  onClose, 
  onCloneSuccess,
  meetingData = null
}) => {
  const [formData, setFormData] = useState({
    name: '',
    description: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isOpen && meetingData) {
      const defaultName = meetingData.name ? `${meetingData.name} copy` : 'Untitled Meeting copy';
      const defaultDescription = meetingData.description || '';
      
      setFormData({
        name: defaultName,
        description: defaultDescription
      });
      setError(null);
    }
  }, [isOpen, meetingData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!meetingData?.instance_id) {
      setError('No meeting selected for cloning');
      return;
    }

    if (!formData.name.trim()) {
      setError('Meeting name is required');
      return;
    }

    try {
      setLoading(true);
      setError(null);
      
      const response = await dataMeet.cloneInstance(
        meetingData.instance_id,
        formData.name.trim(),
        formData.description.trim()
      );
      
      if (response.success) {
        onCloneSuccess(response.instance);
        onClose();
      } else {
        setError(response.message || 'Failed to clone meeting');
      }
    } catch (err) {
      setError('Error cloning meeting: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setFormData({ name: '', description: '' });
    setError(null);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="clone-modal-overlay">
      <div className="clone-modal">
        <div className="clone-modal-header">
          <h3>Clone Meeting</h3>
          <button 
            className="close-button"
            onClick={handleCancel}
            disabled={loading}
          >
            ×
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="clone-form">
          <div className="form-group">
            <label htmlFor="name">Meeting Name *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Enter meeting name"
              required
              disabled={loading}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="description">Description</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              placeholder="Enter meeting description"
              rows="3"
              disabled={loading}
            />
          </div>
          
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}
          
          <div className="clone-modal-actions">
            <button
              type="button"
              className="cancel-button"
              onClick={handleCancel}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="clone-button"
              disabled={loading}
            >
              {loading ? 'Cloning...' : 'Clone'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CloneMeetingModal; 